import React, { useEffect } from "react";
import "@/styles/player-resume-dialog.css";

type PlayerResumeDialogProps = {
  watchedTimeSeconds: number;
  onResume: () => void;
  onStartOver: () => void;
};

function formatWatchedDurationParts(seconds: number): { value: string; unit: string }[] {
  const safe = Math.max(0, Math.floor(seconds));
  const h = Math.floor(safe / 3600);
  const m = Math.floor((safe % 3600) / 60);
  const s = safe % 60;
  const parts: { value: string; unit: string }[] = [];

  if (h > 0) {
    parts.push({ value: h.toLocaleString("fa-IR"), unit: "ساعت" });
  }
  if (m > 0 || h > 0) {
    parts.push({ value: m.toLocaleString("fa-IR"), unit: "دقیقه" });
  }
  parts.push({ value: s.toLocaleString("fa-IR"), unit: "ثانیه" });

  return parts;
}

export default function PlayerResumeDialog({
  watchedTimeSeconds,
  onResume,
  onStartOver,
}: PlayerResumeDialogProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onStartOver();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onStartOver]);

  const durationParts = formatWatchedDurationParts(watchedTimeSeconds);

  return (
    <div className="player-resume-dialog">
      <div className="player-resume-dialog__wrap">
        <div className="player-resume-dialog__center">
          <div
            dir="rtl"
            className="player-resume-dialog__card"
            onClick={(e) => e.stopPropagation()}
          >
            <p className="player-resume-dialog__duration">
              {durationParts.map((part, index) => (
                <span key={part.unit + "-" + String(index)}>
                  <span className="player-resume-dialog__duration-value">{part.value}</span>
                  <span>{" " + part.unit}</span>
                  {index < durationParts.length - 1 ? " " : ""}
                </span>
              ))}
            </p>
            <p className="player-resume-dialog__message">
              از فیلم را تماشا کرده اید آیا میخواهید از ادامه مشاهده کنید؟
            </p>

            <div className="player-resume-dialog__actions">
              <button
                type="button"
                onClick={onResume}
                className="player-resume-dialog__btn player-resume-dialog__btn--primary"
              >
                آره بریم
              </button>
              <button
                type="button"
                onClick={onStartOver}
                className="player-resume-dialog__btn player-resume-dialog__btn--secondary"
              >
                نه، بیخیالش
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
